        (function(){

          function setActiveDuvetUnit() {
          const savedUnit = localStorage.getItem('duvetUnit') || 'cm';
          const btnSelector = savedUnit === 'in' ? '.js-duvet-size-in' : '.js-duvet-size-cm';
          const btn = document.querySelector(`.duvet-size a${btnSelector ? btnSelector : ''}`);

          document.querySelectorAll('.duvet-size a').forEach(el => el.classList.remove('duvet-selected'));
          if (btn) btn.classList.add('duvet-selected');

          updateDuvetSizes(savedUnit);
        }

        function updateDuvetSizes(unit) {
          const cmToInches = 0.3937007874;
          document.querySelectorAll('[data-duvet-size]').forEach(el => {
            const cmText = el.getAttribute('data-duvet-size');
            const [w, h] = cmText.match(/\d+/g).map(Number);
            el.textContent =
              unit === 'in'
                ? `${Math.round(w * cmToInches)}x${Math.round(h * cmToInches)} in`
                : cmText;
          });
        }

        // Run on page load
        //document.addEventListener('DOMContentLoaded', setActiveDuvetUnit);
        setActiveDuvetUnit();

        // Run after variant change
        document.addEventListener('variant:change', setActiveDuvetUnit);

        // Click handling
        document.body.addEventListener('click', e => {
          const btn = e.target.closest('.duvet-size a');
          if (!btn) return;

          e.preventDefault();

          // remove active class from all
          document.querySelectorAll('.duvet-size a').forEach(el => el.classList.remove('duvet-selected'));
          btn.classList.add('duvet-selected');

          const unit = btn.classList.contains('js-duvet-size-in') ? 'in' : 'cm';
          localStorage.setItem('duvetUnit', unit);

          updateDuvetSizes(unit);
        });

        })();